<template>
  <div class="index_wrap">
    <NavbarHeader activeName="home"></NavbarHeader>
    <template>
      <div v-if="bannerList.length>0" style="background-color: #F5F5F5;">
        <swiperList v-if="bannerList.length>0" :bannerList="bannerList" :windowWidth="windowWidth"></swiperList>
      </div>
      <div class="gflex flexcolumn recommend_section">
        <div class="menu_text2">
          <headerTitle englishText="BRAND INTRODUCTION" positiveTitle="品牌介绍"
            subheading="哥弟商元隶属于哥弟公司旗下品牌，专注家居生活版块的电子商务平台"></headerTitle>
        </div>
        <div class="index_erpbrand">
          <div id="index_brand">
            <el-carousel type="card" :height="brandHeight" ref="swiper" :autoplay="false" indicator-position="none"
              :initial-index="currentCampus" @change="changeCampus">
              <el-carousel-item v-for="(item, index) in brandList" :key="index">
                <div class="brand_swiper">
                  <div :class="currentCampus==index?'':'productsfilter'">
                    <img class="brand_img" :src="item.picUrl" />
                  </div>
                  <div class="brand_outcontent">
                    <div class="brand_content flexjccenter flexcolumn" v-if="currentCampus==index">
                      <el-image fit="scale-down" style="max-height: 70px;" v-if="item.brandLogo" :src="item.brandLogo">
                      </el-image>
                      <div style="margin-top: 20px;" v-html="item.brandDesc"></div>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="categray_arrow categray_arrow_left flexcenter flexcolumn">
            <img src="../../assets/image/arrow_left.png" @click="fnPrev()" />
          </div>
          <div class="categray_arrow categray_arrow_right flexcenter flexcolumn">
            <img src="../../assets/image/arrow_right.png" @click="fnNext()" />
          </div>
        </div>
        <!-- <div class="small_brandsection" :style="[{width: windowWidth+'px'}]">
          <div class="small_brand">
            <van-swipe :lazy-render="true" :width="150" :initial-swipe="currentCampus"
             @change="changeBrand">
              <van-swipe-item v-for="(item, index) in brandList" :key="index"
             :style="[{marginLeft: currentCampus==index?'4%':''}]">
                <div style="height: 100%;">
                  <img style="width: 150px;height: 180px;" :src="item.picUrl"
                  :style="[{transform: currentCampus==index?'scale(1)':'scale(0.83)'}]"/>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div> -->
        <template v-if="windowWidth<=480">
          <div class="brand_content" :style="[{width: windowWidth+'px'}]" v-if="brandList[currentCampus]">
            <img v-if="brandList[currentCampus].brandLogo" style="max-height: 35px;"
              :src="brandList[currentCampus].brandLogo"></img>
            <div style="margin-top: 11px;" v-html="brandList[currentCampus].brandDesc"></div>
          </div>
        </template>
        <!-- </div> -->
        <div class="menu_text">
          <headerTitle englishText="RECOMMENDED PLATFORM" positiveTitle="一站式生活好物  推荐平台"
            subheading="带你沉浸式家居美学体验，开启优质生活新旅程"></headerTitle>
        </div>
        <div class="flex flexwrap recommend_menu">
          <div class="recommend_box" v-for="(item, index) in brandCategoryList" :key="index">
            <div class="recommend_outimg">
              <img class="recommend_img" :src="item.picUrl" />
              <img class="recommend_img2" @click="watchcodeUrl(item.codeUrl)" :src="item.picUrl" />

              <div v-if="item.codeUrl" class="recommend_outcode">
                <div class="recommend_code">
                  <el-image class="code_img" style="width: 150px;border-radius: 50%;" ref="QRcode" :src="item.codeUrl" :preview-src-list="[item.codeUrl]">
                  </el-image>
                  <div>扫码查看</div>
                  <div style="display: none;">{{item.codeUrl}}</div>
                </div>
              </div>
            </div>
            <p class="recommend_title">{{item.categoryName}}</p>
            <div class="recommend_subheading" v-html="item.categoryDesc"></div>
          </div>
        </div>
        <div class="menu_text2">
          <headerTitle englishText="HOT NEWS" positiveTitle="热门资讯" subheading="公司最新动态"></headerTitle>
        </div>
        <div class="hot_wrap" id="targetbox">
          <div class="hot_menu" v-for="(item, index) in newsList" :key="index" @click="newswatchInfo(item)">
            <el-image style="width: 563px;height: 346px;" v-if="windowWidth>480" fit="cover" :src="item.picUrl">
            </el-image>
            <el-image style="width: 100%;" v-else fit="cover" :src="item.picUrl"></el-image>

            <div class="flexbet hot_header">
              <div class="hot_title gobyndsingle">{{item.newsTitle}}</div>
              <div class="hot_time">{{item.updateTime}} 发布</div>
            </div>
            <div class="hot_content">{{item.newsAbstract}}</div>
            <div class="hot_checkall">
              <span>查看全文</span>
            </div>
          </div>
        </div>
        <div class="flexcenter work_pages" v-if="windowWidth>480">
          <!--  v-if="newsList.length>4" -->
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage4" :pager-count="11" :page-size="6"
            layout="total, sizes, prev, pager, next, jumper" :total="newsParams.total">
          </el-pagination>
        </div>
        <div v-else class="smallpage">
          <!-- <van-pagination
            @change="handleCurrentChange"
            v-model="currentPage4"
            :total-items="newsParams.total"
            :show-page-size="3"
            force-ellipses
          /> -->
          <div v-if="newsParams.nomore" class="hot_nomore">没有更多了~</div>
          <div class="flexcenter hot_next" v-else @click="nextPage">下一页
            <span class="iconfont icon-xiayiye"></span>
          </div>
        </div>
      </div>
    </template>
    <van-popup v-model="showScancode" closeable position="center"
      :style="{ borderRadius: '10px' }">
      <div class="scancode_wrap flexcenter flexcolumn">
        <div class="codeimg_inner">
          <img class="codeimg" :src="qrCodeurl" />
        </div>
        <p class="codetext">扫码查看分组</p>
      </div>
    </van-popup>
    <footerBar :footerInfo="footerInfo" pageUrl="home"></footerBar>
  </div>
</template>
<script>
  import headerTitle from "@/components/assembly/headerTitle.vue";
  import swiperList from "@/components/assembly/swiperList.vue";
  import footerBar from "@/components/footerBar/footerBar.vue";
  import NavbarHeader from "@/components/NavbarHeader/NavbarHeader.vue";
  import {
    basebrandListapi,
    basebannerListapi,
    newsListbaseapi,
    createQrCodewxapi
  } from "@/api/apilist/commonApi";
  export default {
    components: {
      NavbarHeader,
      footerBar,
      swiperList,
      headerTitle
    },
    transition: 'test',
    data() {
      return {
        windowWidth: 1200,
        brandHeight: '550px',
        showContent: true,
        currentCampus: 0,
        bannerList: [],
        newsList: [],
        newsParams: {
          pageNum: 1,
          pageSize: 6,
          total: 0,
          pages: 1,
          nomore: false, //没有更多了
        },
        brandList: [],
        brandCategoryList: [],
        newsDetail: {},
        currentPage4: 1,
        footerInfo: {
          linkList: [],
          bottomInfo: {}
        },
        total: 0,
        targetSettop: 0,//新闻咨询板块到顶部的距离
        qrCodeurl: '',
        showScancode: false,
      };
    },

    created() {
      this.getbasebannerList();
      this.getbrandwebList();
      // this.getnewswebList();
    },
    activated(){
      this.getnewswebList();
    },
    mounted() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth > 480) {
        this.brandHeight = '550px';
      } else {
        this.brandHeight = '180px';
      }
      window.addEventListener('resize', () => { //监听浏览器窗口大小改变
        //浏览器变化执行动作
        this.windowWidth = window.innerWidth;
        if (this.windowWidth > 480) {
          this.brandHeight = '550px';
        } else {
          this.brandHeight = '180px';
        }
      });
    },
    methods: {
      // 查看二维码
      watchcodeUrl(code){
        if(code){
          this.qrCodeurl = code;
          this.showScancode = true;
        }
      },
      fnPrev() {
        this.$refs.swiper.prev();
      },
      fnNext() {
        this.$refs.swiper.next();
      },
      changeBrand(e) {
        this.currentCampus = e
      },
      getbasebannerList() {
        basebannerListapi({
          bannerType: 1
        }).then(res => {
          this.bannerList = res.data;
        })
      },
      async getbrandwebList() {
        basebrandListapi().then(res => {
          this.brandList = res.data.brandList;
          res.data.brandCategoryList.forEach((item)=>{
            item.codeUrl = 0;
          })
          this.brandCategoryList = res.data.brandCategoryList;
          let that = this;
          for(let i=0;i<this.brandCategoryList.length;i++){
            that.brandCategoryList[i].linkInfo = JSON.parse(that.brandCategoryList[i].linkInfo);
            if(that.brandCategoryList[i].linkInfo.groupId){
              that.getcreateQrCodewx(that.brandCategoryList[i].linkInfo.groupId);
            }

          }
          this.slideBanner()
        })
      },
      async getcreateQrCodewx(groudIp) {
        createQrCodewxapi(
        {
          codeType: "pagesA/mall/mall",
          parameterValue: groudIp
        }).then(res => {
          this.brandCategoryList.forEach((item)=>{
            if(groudIp==item.linkInfo.groupId){
              item.codeUrl = "data:image/gif;base64," + res.data;
              this.$forceUpdate()
            }
          })
        })
      },
      nextPage() {
        if (!this.newsParams.nomore) {
          this.newsParams.pageNum += 1;
          this.getnewswebList();
        }
      },
      getnewswebList() {
        newsListbaseapi(this.newsParams).then(res => {
          if (res.data) {
            if (res.data.list.length > 0) {
              this.newsParams.pages = res.data.pages;
              this.newsParams.total = Number(res.data.total);
              res.data.list.forEach((item) => {
                item.updateTime = item.updateTime.slice(0, 16)
              })
              this.newsList = res.data.list;

              if (res.data.list.length < 4) {
                if (this.newsParams.pageNum == 1) {
                  this.newsParams.nomore = false;
                } else {
                  this.newsParams.nomore = true;
                }
              }
            } else {
              if (this.newsParams.pageNum > 1) {
                this.newsParams.nomore = true;
              }
            }

          }
        })
      },
      gotoHome() {
        this.showContent = true;
        // document.body.scrollTop = this.targetSettop;
      },
      newswatchInfo(item) {
        // this.newsDetail = item;
        // document.documentElement.scrollTop = 0;
        this.$router.push({path: '/newsInfo', query: {newsId: item.newsId}});
        // this.showContent = false;
      },
      changeCampus(e) {
        this.currentCampus = e;
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.$nextTick(() => {
          setTimeout(() => {
            let targetbox = document.getElementById('targetbox');
            document.documentElement.scrollTop = targetbox.offsetTop-250;
          },100)
        })
        this.newsParams.pageNum = val;
        this.getnewswebList();
      },
      // 滑动切换
      	slideBanner() {
      	  //选中的轮播图
      	  var box = document.querySelector('.el-carousel__container');
      	  var startPoint = 0;
      	  var stopPoint = 0;
      	  //重置坐标
      	  var resetPoint = function () {
      	    startPoint = 0;
      	    stopPoint = 0;
      	  }
      	  //手指按下
      	  box.addEventListener("touchstart", function (e) {
      	    //手指点击位置的X坐标
      	    startPoint = e.changedTouches[0].pageX;
      	  });
      	  //手指滑动
      	  box.addEventListener("touchmove", function (e) {
      	    //手指滑动后终点位置X的坐标
      	    stopPoint = e.changedTouches[0].pageX;
      	  });
      	  //当手指抬起的时候，判断图片滚动离左右的距离
      	  let that = this
      	  box.addEventListener("touchend", function (e) {
      	    if (stopPoint == 0 || startPoint - stopPoint == 0) {
      	      resetPoint();
      	      return;
      	    }
      	    if (startPoint - stopPoint > 0) {
      	      resetPoint();
      	      that.$refs.swiper.next();
      	      return;
      	    }
      	    if (startPoint - stopPoint < 0) {
      	      resetPoint();
      	      that.$refs.swiper.prev();
      	      return;
      	    }
      	  });
      	},
    }
  }
</script>

<style scoped lang="less">

  @media screen and (max-width: 480px) {
    .scancode_wrap{
      width: 300px;
      height: 320px;
      border-radius: 10px;
      text-align: center;
      .codeimg_inner{
        padding: 10px;
        border-radius: 50%;
        width: 195px;
        height: 195px;
        margin: 0 auto;
        background-color: #fff;
        overflow: hidden;
      }
      .codeimg{
        width: 180px;
        height: 180px;
      }
      .codetext{
        font-size: 18px;
        margin-top: 22px;
      }
    }
    .hot_nomore {
      line-height: 30px;
      color: #999;
      padding-bottom: 30px;
      text-align: center;
    }
    .menu_text {
      margin: 52px auto 8px;
    }
    .menu_text2 {
      margin: 52px auto 26px;
    }
    .recommend_section {
      width: 100%;
      font-size: 16px;
      padding: 0 15px;
    }
    .small_brandsection {
      overflow: hidden;
      padding: 0 15px;
    }

    .small_brand {
      ::v-deep .van-swipe__indicator--active {
        background-color: #DCC691;
      }
      ::v-deep .van-swipe__track {
        align-items: center;
      }
    }

    .index_erpbrand {
      width: 100%;
      position: relative;
      padding: 0 22px;
      .categray_arrow {
        top: 59px;
        padding: 20px 10px;
        width: 30px;
        background-color: #FFFFFF;
        position: absolute;

        img {
          width: 10px;
          height: 20px;
          cursor: pointer;
        }
      }

      .categray_arrow_left {
        left: -12px;
      }

      .categray_arrow_right {
        right: -12px;
      }
    }

    #index_brand {
      // display: none;
      // width: 100%;
      overflow: hidden;
      padding-left: 5px;
      margin: 0 auto;
      .brand_swiper {
        width: 150px;
        height: 180px;
        .brand_img {
          width: 150px;
          height: 180px;
          border-radius: 5px;
        }
      }
      .productsfilter{
        width: 150px;
        height: 180px;
        border-radius: 5px;
        overflow: hidden;
      }
      ::v-deep .el-carousel__item--card{width: 150px;height: 180px;}
      ::v-deep .el-carousel--horizontal {
        overflow-x: visible;
        // width: 100%;
      }

      ::v-deep .el-carousel__item.is-active {
        width: 150px;
      }

      ::v-deep .el-carousel__arrow {
        width: 10px;
        height: 20px;
        display: none;
      }

      ::v-deep .el-carousel__arrow--left {
        left: auto;
        right: -30px;
      }

      ::v-deep .el-carousel__arrow--right {
        right: auto;
        left: -25px;
      }
    }
    .brand_outcontent{display: none;}
    .brand_content {
      padding: 20px 15px;
      font-size: 16px;
      // img{max-height: 25px; margin-bottom: 11px;}
    }



    .recommend_menu {
      width: 100%;

      .recommend_box:nth-child(odd) {
        padding-right: 7px;
      }

      .recommend_box:nth-child(even) {
        padding-left: 7px;
      }

      .recommend_box {
        width: 50%;
        margin-top: 19px;

        .recommend_outimg {
          position: relative;
          cursor: pointer;
          .recommend_code{display: none;}
          .recommend_img{display: none;}
          .recommend_img2 {
            border-radius: 5px;
          }
        }

        .recommend_title {
          font-size: 16px;
          font-weight: bold;
          line-height: 50px;
        }

        .recommend_subheading {
          font-size: 14px;
          margin-top: -5px;
        }
      }
    }

    .hot_wrap {
      width: 100%;
    }

    .hot_menu {
      width: 100%;
      padding-bottom: 30px;
    }

    .hot_title {
      font-size: 16px;
      font-weight: bold;
      width: 50%;
    }

    .hot_content {
      height: 35px;
      font-size: 14px;
      line-height: 18px;
      margin-top: 5px;
    }

    .hot_checkall {
      margin-top: 10px;
    }
    .smallpage{margin: 20px auto 50px;width: 100%;
      ::v-deep .van-pagination__item{color: #D9BF81;}
      ::v-deep .van-pagination__item--active{color: #fff;background-color: #D9BF81;}
    }
    .hot_next {
      width: 100%;
      height: 40px;
      background-color: #F2F2F2;
      border-radius: 5px;
      margin-bottom: 50px;

      span {
        margin-left: 10px;
      }
    }
  }

  @media screen and (min-width: 481px) {
    .smallpage{display: none;}
    .hot_content {
      height: 45px;}
    .menu_text {
      margin: 100px auto 13px;
    }

    .menu_text2 {
      margin: 114px auto 47px;
    }

    .recommend_section {
      width: 1200px;
      font-size: 16px;
    }

    .small_brandsection {
      display: none;
    }

    .index_erpbrand {
      position: relative;
      width: 100%;

      .categray_arrow {
        top: 0;
        width: 36px;
        height: 100%;
        background-color: #FFFFFF;
        position: absolute;

        img {
          width: 27px;
          height: 50px;
          cursor: pointer;
        }
      }

      .categray_arrow_left {
        left: 0;
      }

      .categray_arrow_right {
        right: 0;
      }
    }

    #index_brand {
      width: 1046px;
      margin: 0 auto;
      overflow: hidden;

      ::v-deep .el-carousel--horizontal {
        overflow-x: visible;
        width: 956px;
        margin-left: -79px;
      }

      ::v-deep .el-carousel__item.is-active {
        width: 810px;
      }

      ::v-deep .el-carousel__container {
        margin-left: 77px;
      }

      ::v-deep .el-carousel__arrow {
        width: 27px;
        height: 50px;
      }

      ::v-deep .el-carousel__arrow--left {
        left: auto;
        right: -242px;
      }

      ::v-deep .el-carousel__arrow--right {
        right: auto;
        left: -75px;
      }
    }

    .brand_content {
      padding: 0 20px;
      width: 406px;
      height: 450px;
      box-shadow: 3px 3px 10px rgba(194, 194, 194, 0.16);
      font-size: 18px;
      align-items: flex-start;
      // img{max-height: 70px; margin-bottom: 20px;}
    }

    .brand_swiper {
      width: 810px;
      height: 550px;
      display: flex;
      align-items: center;
      .brand_img {
        width: 400px;
        height: 550px;
        border-radius: 5px;
      }
    }

    .recommend_menu {
      width: 1280px;

      .recommend_box:nth-child(3n) {
        border: none;
      }

      .recommend_box:last-child {
        border: none;
      }

      .recommend_box {
        width: 425px;
        border-right: 1px solid #F2F2F2;
        padding: 0 37px;
        margin-top: 50px;
        .recommend_outimg:hover .recommend_outcode .recommend_code{display: block;}
        .recommend_outimg {
          width: 350px;
          height: 350px;
          position: relative;
          cursor: pointer;
          overflow: hidden;
          border-radius: 5px;

          .recommend_code{
            width: 350px;
            height: 350px;
            background-color: rgba(0,0,0,0.6);
            color: #fff;
            text-align: center;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 2;
            display: none;
            .code_img{
              width: 150px;
              height: 150px;
              border-radius: 50%;
              margin-top: 80px;
              margin-bottom: 20px;
            }
          }
          .recommend_img {
            width: 350px;
            height: 350px;
            border-radius: 5px;
          }
          .recommend_img2{display: none;}
        }

        .recommend_title {
          font-size: 20px;
          font-weight: bold;
          line-height: 50px;
        }

        .recommend_subheading {
          font-size: 18px;
          margin-top: -5px;
        }
      }
    }

    .hot_wrap {
      width: 1274px;
    }

    .hot_menu {
      width: 637px;
      padding: 50px 37px 0;
      border-right: 1px solid #F2F2F2;
      cursor: pointer;
    }

    .hot_title {
      font-size: 20px;
      font-weight: bold;
      width: 220px;
    }

    .hot_checkall {
      margin-top: 20px;
    }
  }

  .el-pager li:hover {
    color: #DCC691;
  }

  /* PC端css */
  #index_brand {

    // 这里把左右箭头换了，更贴近UI效果
    ::v-deep .el-carousel__arrow--left {
      background-image: url(../../assets/image/arrow_right.png);

      .el-icon-arrow-left {
        opacity: 0;
      }
    }

    ::v-deep .el-carousel__arrow--right {
      background-image: url(../../assets/image/arrow_left.png);

      .el-icon-arrow-right {
        opacity: 0;
      }
    }

    ::v-deep .el-carousel__arrow {
      border-radius: 0px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-color: #FFFFFF;
    }

    .el-carousel__item:nth-child(2n) {
      background-color: #ffffff;
    }

    .el-carousel__item:nth-child(2n+1) {
      background-color: #ffffff;
    }

    .productsfilter {
      filter: blur(3px) brightness(70%);
    }

  }

  .index_wrap {
    background-color: #fff;
  }

  .recommend_section {
    margin: 0 auto;
    background-color: #fff;

    .work_pages {
      margin: 50px 0 100px;

      ::v-deep .el-input__inner {
        border-color: #DCC691;
      }

      ::v-deep .number {
        border: 1px solid #DCC691;
        font-weight: normal;
        margin: 0 5px;
        font-size: 13px;
      }

      ::v-deep .el-pager li.active {
        color: #fff;
        background-color: #DCC691;
      }

      ::v-deep .el-pagination__sizes {
        display: none;
      }
    }

    .hot_wrap {
      display: flex;
      flex-wrap: wrap;

      .hot_menu:nth-child(2) {
        padding-top: 0;
      }

      .hot_menu:nth-child(1) {
        padding-top: 0;
      }

      .hot_menu:nth-child(even) {
        border: none;
      }
    }

    .hot_header {
      padding: 5px 0;

      .hot_time {
        color: #C2C2C2;
      }
    }

    .hot_content {
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

    .hot_checkall {
      color: #D9BF81;

      span {
        cursor: pointer;
      }
    }
  }
</style>
